import React from 'react';

import { RecordMeasurement } from "@/features/inspection-details/components/record-measurement/components/RecordMeasurement.tsx";
import { DynamicComponentProps } from '@/types/ModuleComponentProp.type';

export const ProductDimensionCheck: React.FC<DynamicComponentProps> = (props: DynamicComponentProps) => {

    return (
        <RecordMeasurement {...props}></RecordMeasurement>
    )
}